/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Document on Azure Functions
 * This is the OpenAPI Document on Azure Functions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  DeleteEntity,
  PartialBranch,
  PartialSupplier,
  SetSupplierName,
  SetSupplierReference,
  SupplierBranch,
} from '../models/index';
import {
    DeleteEntityFromJSON,
    DeleteEntityToJSON,
    PartialBranchFromJSON,
    PartialBranchToJSON,
    PartialSupplierFromJSON,
    PartialSupplierToJSON,
    SetSupplierNameFromJSON,
    SetSupplierNameToJSON,
    SetSupplierReferenceFromJSON,
    SetSupplierReferenceToJSON,
    SupplierBranchFromJSON,
    SupplierBranchToJSON,
} from '../models/index';

export interface DeleteBranchRequest {
    body: DeleteEntity;
}

export interface DeleteSupplierRequest {
    body: DeleteEntity;
}

export interface StartSupplierImportRequest {
    body: string;
}

export interface UpdateSupplierBranchRequest {
    body: SupplierBranch;
}

export interface UpdateSupplierNameRequest {
    body: SetSupplierName;
}

export interface UpdateSupplierReferenceRequest {
    body: SetSupplierReference;
}

/**
 * 
 */
export class SupplierApi extends runtime.BaseAPI {

    /**
     * Clears (deletes) all suppliers and corresponding branches
     */
    async clearSuppliersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/ClearSuppliers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Clears (deletes) all suppliers and corresponding branches
     */
    async clearSuppliers(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.clearSuppliersRaw(initOverrides);
    }

    /**
     * Commit suppliers to GINO
     */
    async commitSuppliersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/CommitSuppliers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Commit suppliers to GINO
     */
    async commitSuppliers(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.commitSuppliersRaw(initOverrides);
    }

    /**
     * Deletes a SupplierBranch
     */
    async deleteBranchRaw(requestParameters: DeleteBranchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling deleteBranch().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/DeleteBranch`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DeleteEntityToJSON(requestParameters['body']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes a SupplierBranch
     */
    async deleteBranch(requestParameters: DeleteBranchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteBranchRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes a Supplier
     */
    async deleteSupplierRaw(requestParameters: DeleteSupplierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling deleteSupplier().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/DeleteSupplier`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DeleteEntityToJSON(requestParameters['body']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes a Supplier
     */
    async deleteSupplier(requestParameters: DeleteSupplierRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteSupplierRaw(requestParameters, initOverrides);
    }

    /**
     * Get all SupplierBranches
     */
    async getAllBranchesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PartialBranch>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/GetAllBranches`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PartialBranchFromJSON));
    }

    /**
     * Get all SupplierBranches
     */
    async getAllBranches(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PartialBranch>> {
        const response = await this.getAllBranchesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Get all Suppliers
     */
    async getAllSuppliersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<PartialSupplier>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/GetAllSuppliers`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(PartialSupplierFromJSON));
    }

    /**
     * Get all Suppliers
     */
    async getAllSuppliers(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<PartialSupplier>> {
        const response = await this.getAllSuppliersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Start Supplier import
     */
    async startSupplierImportRaw(requestParameters: StartSupplierImportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling startSupplierImport().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/StartSupplierImport`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Start Supplier import
     */
    async startSupplierImport(requestParameters: StartSupplierImportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.startSupplierImportRaw(requestParameters, initOverrides);
    }

    /**
     * Update a SupplierBranch
     */
    async updateSupplierBranchRaw(requestParameters: UpdateSupplierBranchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling updateSupplierBranch().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/UpdateBranch`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SupplierBranchToJSON(requestParameters['body']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update a SupplierBranch
     */
    async updateSupplierBranch(requestParameters: UpdateSupplierBranchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateSupplierBranchRaw(requestParameters, initOverrides);
    }

    /**
     * Update a SupplierName
     */
    async updateSupplierNameRaw(requestParameters: UpdateSupplierNameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling updateSupplierName().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/UpdateSupplierName`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SetSupplierNameToJSON(requestParameters['body']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update a SupplierName
     */
    async updateSupplierName(requestParameters: UpdateSupplierNameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateSupplierNameRaw(requestParameters, initOverrides);
    }

    /**
     * Update a Supplier ClientRef
     */
    async updateSupplierReferenceRaw(requestParameters: UpdateSupplierReferenceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling updateSupplierReference().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/UpdateSupplierReference`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SetSupplierReferenceToJSON(requestParameters['body']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update a Supplier ClientRef
     */
    async updateSupplierReference(requestParameters: UpdateSupplierReferenceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateSupplierReferenceRaw(requestParameters, initOverrides);
    }

}
